import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import * as backendModule from "./modules/backendModule";
import Spinner from "./Components/Spinner";

import "./App.css";

import Home from "../src/Pages/Home";
import About from "../src/Pages/About";
import Shop from "../src/Pages/Shop";
import Contact from "../src/Pages/Contact";
import Blog from "../src/Pages/Blog";
import Header from "../src/Components/Header/Navbar";
import Footer from "../src/Components/Footer/Footer";
import ProductDetails from "./Pages/ProductDetails";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./Components/ScrollButton/ScrollToTop";
import Authentication from "./Pages/Authentication";
import ResetPass from "./Components/Authentication/Reset/ResetPass";
import BlogDetails from "./Components/Blog/BlogDetails/BlogDetails";
import TermsConditions from "./Pages/TermsConditions";
import ShoppingCart from "./Components/ShoppingCart/ShoppingCart";
import Dashboard from "../src/Components/Dashboard/Dashboard";
import Products from "../src/Components/Products/Products";
import Orders from "./Components/Orders/Orders";
import OrderInfo from "./Components/OrderInfo/OrderInfo";
import AddNew from "./Components/AddNew/AddNew";
import EditProduct from "./Components/EditProduct/EditProduct";
import { Toaster } from "react-hot-toast";
import PaymentResult from "./Components/PaymentResult/PaymentResult";
import PrivacyPolicy from "./Pages/PrivacyPolicy";

const App = () => {
  const [logged, setLogged] = React.useState(false);
  const [userData, setUserData] = React.useState([]);
  const [spinner, setSpinner] = React.useState(true);

  const location = useLocation();

  const isAdminPage = location.pathname.includes("admin");

  const checkLogin = async () => {
    try {
      const res = await axios.post(`${backendModule.backendURL}/auth/checkLogin`, {}, backendModule.axiosConfig);
      if (res.data.status === "ok") {
        const userInfo = res.data.data.UserInfo;
        setUserData(userInfo);
        setLogged(true);
      } else {
        setLogged(false);
      }
    } catch {
      setLogged(false);
    } finally {
      setSpinner(false);
    }
  };

  React.useEffect(() => {
    checkLogin();
  }, [location.pathname]);

  if (spinner) return <Spinner style={{ width: '64px', height: '50px', marginLeft: 'auto', marginRight: 'auto', marginTop: '50px', display: 'block' }} color='white' />;

  return (
    <>
      <ScrollToTop />
      {!isAdminPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/product" element={<ProductDetails />} />
        <Route path="/loginSignUp" element={<Authentication />} />
        <Route path="/resetPassword" element={<ResetPass />} />
        <Route path="/BlogDetails" element={<BlogDetails />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/cart" element={<ShoppingCart />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
        {logged && <Route path="/admin/dashboard" element={<Dashboard />} />}
        {logged && <Route path="/admin/products" element={<Products />} />}
        {logged && <Route path="/admin/products/addNew" element={<AddNew />} />}
        {logged && <Route path="/admin/products/editProduct" element={<EditProduct />} />}
        {logged && <Route path="/admin/orders" element={<Orders />} />}
        {logged && <Route path="/admin/orders/orderInfo" element={<OrderInfo />} />}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdminPage && <Footer />}
      <Toaster />
    </>
  );
};

export default App;
